/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FileAttachmentDto
 */
export interface FileAttachmentDto {
    /**
     * Firebase Storage URL of the uploaded file
     * @type {string}
     * @memberof FileAttachmentDto
     */
    url: string;
    /**
     * Original filename
     * @type {string}
     * @memberof FileAttachmentDto
     */
    filename: string;
    /**
     * MIME type of the file (supports images, documents, audio, video)
     * @type {string}
     * @memberof FileAttachmentDto
     */
    mimeType: string;
    /**
     * File size in bytes
     * @type {number}
     * @memberof FileAttachmentDto
     */
    size?: number;
    /**
     * Duration in seconds (for audio and video files)
     * @type {number}
     * @memberof FileAttachmentDto
     */
    duration?: number;
    /**
     * Thumbnail URL (for video files)
     * @type {string}
     * @memberof FileAttachmentDto
     */
    thumbnail?: string;
}

/**
 * Check if a given object implements the FileAttachmentDto interface.
 */
export function instanceOfFileAttachmentDto(value: object): value is FileAttachmentDto {
    if (!('url' in value) || value['url'] === undefined) return false;
    if (!('filename' in value) || value['filename'] === undefined) return false;
    if (!('mimeType' in value) || value['mimeType'] === undefined) return false;
    return true;
}

export function FileAttachmentDtoFromJSON(json: any): FileAttachmentDto {
    return FileAttachmentDtoFromJSONTyped(json, false);
}

export function FileAttachmentDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FileAttachmentDto {
    if (json == null) {
        return json;
    }
    return {
        
        'url': json['url'],
        'filename': json['filename'],
        'mimeType': json['mimeType'],
        'size': json['size'] == null ? undefined : json['size'],
        'duration': json['duration'] == null ? undefined : json['duration'],
        'thumbnail': json['thumbnail'] == null ? undefined : json['thumbnail'],
    };
}

export function FileAttachmentDtoToJSON(json: any): FileAttachmentDto {
    return FileAttachmentDtoToJSONTyped(json, false);
}

export function FileAttachmentDtoToJSONTyped(value?: FileAttachmentDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'url': value['url'],
        'filename': value['filename'],
        'mimeType': value['mimeType'],
        'size': value['size'],
        'duration': value['duration'],
        'thumbnail': value['thumbnail'],
    };
}

